import { NavBar } from '@/v2/components/NavBar';
import PageWithTOC from '@/components/PageWithTOC';
import type { Section } from '@/components/PageWithTOC';
import { PRODUCT_EMAIL, PRODUCT_NAME } from '@/shared/constance';


const privacyPolicySections: Section[] = [
  {
    id: 'introduction',
    title: '',
    content: (
      <p className="span-normal text-base text-content-primary">
        STREAMLAKE PTE. LTD.（连同我们的关联公司，"公司"、"{PRODUCT_NAME}
        "、"我们"、"我们的"或"我们"）尊重您的隐私，并强烈致力于保护我们从您那里或关于您获得的任何信息的安全。本隐私政策描述了我们在处理从您那里或关于您收集的个人数据方面的做法，以及我们处理这些数据的基础。您的个人数据是指关于您的数据，无论是否真实，可以从（a）该数据或（b）该数据和我们拥有或可能拥有访问权限的其他信息中识别（"
        <span className="span-semibold">数据</span>
        "）。通过使用服务，包括访问或使用平台、联系或与我们互动或向我们提交信息，您同意本政策的条款以及根据本政策收集、使用、披露和处理您的数据。在本政策中，"您"或"您的"是指购买或使用任何服务的任何用户，包括我们平台的任何用户。
      </p>
    ),
  },
  {
    id: 'contents',
    title: '本隐私政策的内容',
    content: (
      <div className="span-normal text-base text-content-primary">
        <ol className="list-decimal pl-4">
          <li>我们收集的数据</li>
          <li>我们如何使用您的数据</li>
          <li>我们处理数据的法律依据</li>
          <li>数据存储和保留</li>
          <li>数据安全和保护</li>
          <li>我们可能向谁披露或转移您的数据</li>
          <li>国际数据传输</li>
          <li>您与个人数据相关的权利</li>
          <li>Cookies</li>
          <li>应用程序</li>
          <li>政策变更</li>
          <li>父母和监护人同意</li>
          <li>联系信息</li>
          <li>国家/地区特定条款</li>
        </ol>
      </div>
    ),
  },
  {
    id: 'Data We Collect',
    title: '1. 我们收集的数据',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>我们可能从各种来源收集来自您或您的设备的各种数据，如下所述。</p>
        <p>
          我们收集的数据类型取决于您如何使用服务。服务提供可选功能，如果您使用这些功能，需要我们收集可选数据以提供此类功能。您将在适当时收到此类收集的通知。
        </p>
        <p>
          如果您在被要求时不提供您的数据，如果该数据对于向您提供我们的服务是必要的，或者如果我们在法律上被要求收集此类数据，您可能无法使用我们的服务。
        </p>
        <p className="span-semibold">A. 您提供的个人数据</p>
        <ul className="list-disc">
          <li>
            <span className="span-semibold">账户和个人资料信息。</span>{' '}
            当您注册账户时，您可以使用第三方平台账户（GitHub
            账户）登录，我们将根据您的授权获取第三方账户下的相关信息（包括：用户名、昵称、头像等）。我们承诺收集上述信息是为了为您提供账户登录服务，保护您的账户安全并防范安全风险。如果您拒绝授权此类信息，您将无法使用第三方平台的账户登录我们的平台。
          </li>
          <li>
            <span className="span-semibold">您通过我们的产品提供的内容。</span>{' '}
            作为服务的一部分，我们收集并存储您通过我们的产品发布、发送、接收和共享的内容。这包括您的输入（您可以通过语音输入）和输出，例如问题、提示、您的代码库文件以及您输入、上传或提交到服务的其他内容，以及您创建的输出。此内容可能构成或包含个人信息，具体取决于内容的实质以及它如何与您的账户相关联。我们使用此信息作为服务的一部分生成和输出新内容。
            <p className="mt-2">
              注意：为了为您提供代码库索引，您的代码库文件将上传到我们的服务器以计算嵌入。我们将保留和存储嵌入以及相关元数据和代码库文件。如果您不希望我们保留，您可以选择删除代码库索引，一旦您选择删除，我们将删除您的代码库以及在我们服务器中生成的嵌入和相关元数据。
            </p>
            <p className="mt-2">
              当您与平台集成的 AI
              聊天机器人交互时，我们会收集您选择输入的任何信息（包括任何代码片段）。
            </p>
          </li>
          <li>
            <span className="span-semibold">通信信息。</span>{' '}
            如果您与我们沟通，我们将收集您的电子邮件地址、联系信息以及您发送给我们的任何消息内容。
          </li>
          <li>
            <span className="span-semibold">支付和账单信息。</span> 当您在 {PRODUCT_NAME}{' '}
            上使用某些付费服务时，我们会收集您的支付和账单信息。您可能还需要向第三方安全支付处理服务提供商提供信用卡信息。我们不存储您的信用卡信息。
          </li>
        </ul>

        <p className="span-semibold">B. 我们自动收集的个人数据</p>
        <ul className="list-disc">
          <li>
            <span className="span-semibold">网络和设备信息。</span>{' '}
            当您使用我们的服务时，我们可能会自动收集您的数据，包括用户 ID、密码、令牌、数字证书、IP
            地址、设备 ID 或特征、cookies、广告标识符、WiFi/WLAN
            蓝牙、移动网络信息、应用程序和文件名（须经您同意）。
          </li>
          <li>
            <span className="span-semibold">使用信息。</span>{' '}
            我们自动收集有关您如何使用平台的信息，包括您何时以及如何注册和登录平台以及您使用平台的持续时间和频率。当您与我们的
            AI 聊天机器人互动时，我们还会收集您提供的任何反馈、AI 生成的输出以及相关元数据。
          </li>
          <li>
            <span className="span-semibold">Cookies。</span> 我们可能通过使用网站 cookies
            收集您的数据，以便操作和管理我们的服务，并改善您的用户体验。"cookie"
            是您访问的网站发送到您浏览器的一段信息。您可以设置浏览器接受 cookies 或拒绝
            cookies。但是，在某些情况下，拒绝 cookie
            可能会阻止您使用网站或网站的某些区域或功能，或对其显示或功能产生负面影响。
          </li>
          <li>
            <span className="span-semibold">分析。</span> 我们可能使用各种在线分析产品，这些产品使用
            cookies 来帮助我们分析用户如何使用我们的服务，并增强您使用我们服务时的体验。
          </li>
        </ul>
        <p>
          我们收集的关于您的数据的类别和范围可能会不时变化，这取决于您对 {PRODUCT_NAME}{' '}
          的选择和互动，以及您使用 {PRODUCT_NAME} 的国家或地区。我们将在适当时通知您此类变化。
        </p>
        <p>
          在功能可用的情况下，您可以选择在不登录账户或注册的情况下浏览平台上的某些内容，在这种情况下，我们仍可能收集某些数据，包括您浏览的内容、您与平台的互动以及与您的设备信息相关的数据，如设备
          ID、WiFi 信息和 IP 地址。
        </p>
        <p className="span-semibold">C. 数据组合</p>
        <p>
          通过使用我们的服务，您同意我们可以将从您那里和关于您收到的数据结合起来，包括您提供的数据和我们如上所述自动收集的数据，以及我们可能从第三方收到的数据，以帮助我们为您量身定制我们的沟通并改进我们的服务。如果您不同意本部分，请不要使用平台或任何服务。
        </p>
        <p>
          您可能需要在以下情况下向我们提供某些类型的数据：(i)根据任何法律、法规或指南的要求；(ii)根据我们之间签订的任何合同的要求；(iii)为了让我们与您签订任何合同或协议的要求；(iv)或者您有义务向我们提供数据。如果是这种情况，我们将单独通知您，并解释如果您未能向我们提供此类数据可能产生的后果。在其他所有情况下，提供所请求的数据是可选的，并且可能不会影响您对我们一般服务的基本使用，但它可能会影响您使用特定服务的能力，其中数据是那些目的所必需的。
        </p>
      </div>
    ),
  },
  {
    id: 'how-we-use-your-data',
    title: '2. 我们如何使用您的数据',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>我们可能将您的数据用于与运营我们的业务和向您提供服务相关的多种目的，包括：</p>
        <ul className="list-disc">
          <li>
            <span className="span-semibold">身份识别与验证。</span>{' '}
            我们使用您的数据来验证您的身份或资格，以便您访问和使用我们的服务，例如领取奖励或奖品，或在您与其他用户互动或与我们互动时，以保护您的数据安全。在某些情况下，我们使用您的数据来验证您的年龄，以便为您提供某些服务，或验证您的身份，以便处理您与您的数据相关的请求。
          </li>
          <li>
            <span className="span-semibold">服务提供。</span>{' '}
            我们处理您的数据，以为您提供您请求的服务，回答您的查询，或就 {PRODUCT_NAME}{' '}
            平台或我们任何服务的变更与您联系，并管理我们与您的关系。这可能还包括管理 {PRODUCT_NAME}{' '}
            的内容生态系统，或其部分方面，促进 {PRODUCT_NAME}{' '}
            上的第三方合作伙伴关系或集成，监控和测试 {PRODUCT_NAME}
            ，解决问题，或允许您与其他用户连接。
          </li>
          <li>
            <span className="span-semibold">支付处理。</span>{' '}
            我们可能会使用您的数据用于账单和支付处理目的，或用于向您发放奖励或收回我们应得的款项。这也可能包括通过第三方支付系统进行支付。
          </li>
          <li>
            <span className="span-semibold">服务改进、研究和功能开发。</span>{' '}
            我们检查和分析使用信息和统计数据，以维护和改进 {PRODUCT_NAME}
            。我们还可以使用您的数据支持客户服务并实施用户反馈，进行调查，或改进、研究和发展新的产品和服务，或为我们的业务运营开发新的流程方法。
          </li>
          <li>
            <span className="span-semibold">通讯。</span>{' '}
            我们可能会使用您的数据与您联系和沟通。通讯可能包括，例如，提供有关我们的服务的信息、对本政策的更改、对我们服务条款的更改、对我们付费服务条款的更改、有关我们服务的更新、关于未成年用户的信息报告，或对您的疑问、评论或请求的回复。
          </li>
          <li>
            <span className="span-semibold">内容安全。</span> 为确保 {PRODUCT_NAME}{' '}
            的安全、稳定和可靠性，我们可能会扫描、分析和审查用户内容，以检测和打击有害活动及内容、欺诈、非法活动或内容。
          </li>
          <li>
            <span className="span-semibold">偏好、促销和销售。</span>{' '}
            我们可能会使用您的数据来建立您的个人资料，分析并了解您的偏好，帮助确定哪些营销材料可能对您感兴趣，展示广告，开展奖励活动，衡量广告和促销的效果，并促进销售、购买和交付（如适用）。我们还可以以上述方式处理您的数据，以开展抽奖、竞赛或其他促销活动。
          </li>
          <li>
            <span className="span-semibold">行使我们的权利。</span>{' '}
            在必要时，我们可能会使用您的数据来行使我们的权利，例如检测、预防、调查和应对安全事件或漏洞、数据抓取、欺诈、滥用、知识产权侵权索赔以及任何其他索赔、金融犯罪、其他违反法律的行为、违反我们的服务条款或违反我们的付费服务条款。
          </li>
          <li>
            <span className="span-semibold">履行我们的义务。</span>{' '}
            我们可能会处理您的数据以履行法律或监管义务、行为准则、指南或规则，包括但不限于我们防止未达到最低年龄（如下定义）的用户访问平台或应用程序的法律义务，以应诉、回应诉讼、索赔或调查，协助任何政府和/或监管机构在任何合并、收购、销售和资产转让、破产程序、公司重组、清算或解散的情况下的执法和调查，无论是在您所在国家或地区内还是外。我们还可能汇总和/或匿名化您的数据，并可在适用法律允许的范围内使用此类汇总或识别信息用于任何其他目的。
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: 'legal-basis',
    title: '3. 我们处理数据的法律依据',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          为了处理您的数据，我们将依赖适用法律和法规所赋予的法律基础。只有在我们拥有有效的"法律依据"时，我们才会处理您的数据，包括如下所述。
        </p>
        <ul>
          <li>
            <span className="span-semibold">同意。</span>{' '}
            我们可能会处理您的数据，如果您已同意对您的数据进行某些处理。例如，如果您同意使用
            Cookie，我们可能会处理您的数据以使用 Cookie。
          </li>
          <li>
            <span className="span-semibold">合同必要性。</span>{' '}
            我们可能会处理您的数据，以为您提供您所请求的服务，或为完成您与我们之间的任何交易所必需。例如，我们可能需要使用或处理您的数据来回应您的查询或请求。
          </li>
          <li>
            <span className="span-semibold">遵守法律义务。</span>{' '}
            我们可能会处理您的数据，因为我们有法律义务这样做。例如，我们可能会处理您的数据以遵守税务、劳动和会计义务。
          </li>
          <li>
            <span className="span-semibold">合法利益。</span>{' '}
            我们可能会处理您的数据，因为我们或第三方有处理您的数据的合法利益。具体而言，我们有权使用您的数据用于产品开发和内部分析目的，以及改进我们服务的安全性、安全性和性能。只有当这些利益不被您的权利和利益所覆盖时，我们才会依赖我们或第三方的合法利益来处理您的数据。
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: 'data-storage',
    title: '4. 数据存储和保留',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          我们将在提供服务所需的时间内保留您的数据，或根据法律要求保留。当您删除账户或我们不再需要您的数据时，我们将删除或匿名化您的数据，除非法律要求我们保留更长时间。
        </p>
        <p>我们使用行业标准的安全措施来保护您的数据，包括加密、访问控制和定期安全审计。</p>
      </div>
    ),
  },
  {
    id: 'data-security',
    title: '5. 数据安全和保护',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          我们实施适当的技术和组织措施来保护您的数据免受未经授权的访问、使用、披露、更改或销毁。这些措施包括但不限于：
        </p>
        <ul className="list-disc">
          <li>使用加密技术保护数据传输和存储</li>
          <li>实施访问控制和身份验证程序</li>
          <li>定期进行安全评估和漏洞测试</li>
          <li>对员工进行数据保护培训</li>
          <li>建立事件响应程序</li>
        </ul>
        <p>
          尽管我们采取了这些措施，但请注意，没有任何通过互联网传输或电子存储的方法是100%安全的。因此，我们不能保证绝对安全。
        </p>
      </div>
    ),
  },
  {
    id: 'data-disclosure',
    title: '6. 我们可能向谁披露或转移您的数据',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>我们可能会在以下情况下披露或转移您的数据：</p>
        <ul className="list-disc">
          <li>
            <span className="span-semibold">服务提供商。</span>{' '}
            我们可能与帮助我们运营服务的第三方服务提供商共享您的数据，如云存储提供商、分析服务提供商和支付处理商。
          </li>
          <li>
            <span className="span-semibold">法律要求。</span>{' '}
            当法律要求或为了保护我们的权利、财产或安全，或保护其他用户或公众的权利、财产或安全时，我们可能会披露您的数据。
          </li>
          <li>
            <span className="span-semibold">业务转移。</span>{' '}
            在合并、收购、资产出售或其他业务转移的情况下，我们可能会转移您的数据。
          </li>
          <li>
            <span className="span-semibold">同意。</span>{' '}
            在您明确同意的情况下，我们可能会披露您的数据。
          </li>
        </ul>
        <p>我们不会出售、出租或以其他方式商业化您的个人数据。</p>
        <li>
          除本隐私政策明确规定的以外，我们不会与任何第三方共享或转移您的任何数据。我们仅在以下情况下与第三方共享您的数据：
          <ul className="mt-2 list-disc space-y-2 pl-8">
            <li>
              当经你批准或授权，或受"家长和监护人同意"条款约束时 下面的部分，你的父母或法定监护人；
            </li>
            <li>根据行政或司法需要，包括任何相关要求， 有权机关、法院和监管机构；</li>
            <li>在任何涉及我们的法律诉讼（包括任何仲裁）中，我们旨在 保护我们的合法权益；</li>
            <li>在服务条款明确允许的情况下；</li>
            <li>为了保护公司利益，或任何个人或 公众利益免受损害；</li>
            <li>用于进一步存档或与其他第三方去识别化。</li>
          </ul>
        </li>
        <li>
          我们可能会将您的数据分享给我们的企业附属公司、集团成员和其他第三方
          相关方，他们仅将根据本政策使用您的数据，以促进 向您提供{PRODUCT_NAME}或用于下述其他目的：
          <ul className="mt-2 list-disc space-y-2 pl-8">
            <li>
              <span className="span-semibold">在包含合并、收购或资产出售的交易中：</span>{' '}
              我们可能会将您的数据转移给另一法人在合作目的下使用
              合资企业，公司重组，法律形式变更或其他类似事件
              或交易。为了发展我们的业务，我们可能会进行交易。
              在合并、收购、销售和资产转让等情况下，我们将 通知您相关交易，并将继续保护或要求
              后继者根据适用法律、法规和 本政策保护您的数据。
            </li>
            <li>
              <span className="span-semibold">支持{PRODUCT_NAME}的第三方：</span>我们
              与帮助运营、提供、改进、整合我们的第三方共享信息
              定制、支持和市场我们的服务。例如，为了向您提供服务，
              我们可能会与提供咨询服务的第三方服务合作伙伴共享信息
              支持。我们与第三方服务提供商合作，他们提供网站和
              应用开发，托管，维护，备份，存储，虚拟
              基础设施、支付处理、分析和其他服务给我们。这些服务
              可能需要服务提供者访问或使用您的信息。我们也可能
              将您的数据分享给与我们合作的专业机构和个人，以提供
              向我们提供专业服务，包括顾问、审计师、律师和会计师。我们
              将只会根据需要向第三方分享您的数据，以便他们
              执行相应的职能和服务，我们将要求这些相关方
              采取适当的安全措施来保护这些数据免受未经授权的访问 或处理。
            </li>

            <li>
              <span className="span-semibold">第三方平台和合作伙伴。 </span>
              我们可能会与那些平台或服务与我们的平台集成的第三方共享某些您提供的信息、技术信息和使用
              信息。 平台。例如，如果您使用第三方
              账户详细信息注册或登录平台，我们将共享某些技术信息以促进账户
              注册或登录。如果您选择使用第三方
              集成来部署您的项目，我们将共享您所选项目的代码库文件以促进 部署。
            </li>

            <li>
              <span className="span-semibold">法律、监管或政府机构：</span>我们
              在有限情况下，可能会将您的数据转移到您所在地的本地或海外
              法律、监管、执法、政府和税务等机构 当局，以满足我们的义务或第三方的义务（当他们收到
              根据法律授权的机构提出的请求（如需），并依照相关法律 规定。
            </li>
          </ul>
        </li>
        <li>
          除非本政策另有规定，否则我们将不会披露任何数据 从您使用{PRODUCT_NAME}
          收集的信息公开给公众。如果需要公开 根据相关法律法规，我们将告知您信息披露的目的
          以及披露信息的类型。
        </li>
        <p className="span-semibold mt-4">
          法律原因 如果我们有善意地相信可以访问、使用、保存或 公开此类数据在合理情况下是必要的：
        </p>
        <ul className="mt-2 list-disc space-y-2 pl-8">
          <li>遵守任何适用的法律、法规，或开始或回应任何法律 流程或诉讼，或可执行的政府请求，</li>
          <li>维护我们的权利或财产，</li>
          <li>防止欺诈或犯罪活动，</li>
          <li>在紧急情况下回应以保护任何实体、个人或团体的个人安全， 或</li>
          <li>避免或减轻法律责任。</li>
        </ul>
        <p className="span-semibold mt-4">商业转让</p>
        如果我们涉及重组、合并、收购、资产出售或
        在清算过程中，我们将继续确保您的数据的机密性，并通知
        <p>受影响的用户，他们的数据将被转移或可能受到不同的隐私保护 提前制定政策。</p>
      </div>
    ),
  },
  {
    id: 'international-data-transfer',
    title: '7. 国际数据传输',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          我们可能会将您的数据转移到您所在国家以外的国家或地区
          仅用于本政策中规定的目的，并依照本政策 以及适用的法律法规。本政策中提到的数据披露可能
          涉及将您的数据传输到提供不同级别的国家或地区 数据保护。已考虑适用的法律和监管要求
          在你任何数据跨境转移之前，我们的政策如下：
        </p>
        <p>
          我们可能会将您的数据与其他司法管辖区的集团实体进行内部共享， 为了运营{PRODUCT_NAME}
          并向您提供服务，用于业务和运营目的 访问服务。我们将通过适当的合同保证来确保
          必须遵守相关法律法规，所有我们与之 分享你的数据，并采取适当的安全措施来保护你的数据免受
          未经授权的访问或处理，且不会将此数据与任何第三方共享 除非你明确同意其他方式。
        </p>
      </div>
    ),
  },

  {
    id: 'your-rights',
    title: '8. 您与个人数据相关的权利',
    content: (
      <div className="span-normal text-base text-content-primary">
        <ol className="list-decimal space-y-4 pl-4">
          <li>
            一旦您完成了账户注册并采取了合理的措施和
            如果采取必要的身份验证措施，您可以查看、修改和删除您拥有的数据
            通过使用"联系我们"中提供的联系方式向我们提交
            本政策的“信息”部分。通常，您可以浏览、修改和删除您的
            随时查看自己的信息，但你可能无法修改某些初始设置 注册信息及验证信息在注册时提供
            为安全和身份识别目的进行注册。
          </li>
          <li>
            根据当地法律，您可能拥有以下权利： 通过使用联系信息与我们联系，您可以行使这些规定
            本政策中“联系方式”部分提供的信息：
            <ul className="mt-2 list-disc space-y-2 pl-8">
              <li>
                你有权获得简洁、透明、清晰且易于理解的信息
                您有权以可访问的形式了解您的数据是如何被处理的。您还有权
                以确认是否正在处理您的数据， 如此处理属实，则访问该数据并获取副本。
              </li>
              <li>您有权要求更正您的数据。您还有权 使不完整的数据完整。</li>
              <li>
                如果您已提供同意，您有权撤回您的同意。 如果你撤回同意，我们可能会继续处理你的数据至
                由适用法律和/或本政策规定的。
              </li>
              <li>
                你有权以结构化、常用和 机器可读的格式接收你的数据，并有权将这些数据传输给另一个
                控制者。
              </li>
              <li>您有权要求删除或限制您的数据，如法律法规所允许 依法。</li>
              <li>
                你有权反对我们处理你的数据，例如，如果我们
                根据相关法律的规定，处理您的数据用于直接营销目的。
              </li>
              <li>
                你有权删除你的账户，这是一个不可逆的过程，因为删除后你将
                无法再访问你的账户，并且所有与账户相关的数据都将
                账户将被删除或去识别化，具体取决于任何法定保留要求
                需要遵守相关法律法规的要求。如果您希望您的账户
                已删除，您可以通过"联系我们"中提供的联系方式与我们联系 本政策的“信息”。
              </li>
              <li>
                您也可能拥有其他权利，具体请参见“国家/地区特定”下的说明
                术语"部分下方或根据当地法律的其他规定。
              </li>
            </ul>
          </li>
          <li>
            我们将在满足您的要求之前首先验证您的身份。我们将根据当地法律要求或允许的时间范围内回应
            您的要求。
          </li>
          <li>你还可以按照下文所述更改你的 cookie 设置来 管理我们使用 cookies 收集的数据。</li>
          <li>你可以通过暂停某些我们提供的功能来阻止我们获取你的数据 我们的服务。</li>
        </ol>
        <p className="mt-4">
          你可以通过联系我们来免费行使上述权利，联系方式为 contact
          本政策的“联系方式”部分中的详细信息。如果要求明显
          没有根据或过度，特别是由于请求的重复性质，我们
          将向你收取合理的费用，或者拒绝满足你的请求。
        </p>
        <p className="mt-4">
          我们将向你提供关于请求后续处理的信息，而不造成不当
          延迟，并且通常在收到请求后一个月内。适用的隐私
          法律可能允许或要求我们拒绝您的请求。如果我们无法满足您的
          请求，我们将告知您原因，但需遵守任何法律或监管 限制。
        </p>
        <p className="mt-4">
          这些权利并非绝对，在某些情况下可能会受到限制。例如，
          如果我们能证明有法律要求处理您的数据，或者 如果向您提供信息会泄露其他个人的个人数据，
          如果我们依法被禁止披露此类信息。在某些情况下，这可能
          意味着我们即使您撤回同意，也能保留您的数据。
        </p>
        <p className="mt-4">
          我们希望能够满足您对我们处理数据的任何疑问。 如果你仍然存在未解决的担忧，你也有权提出申诉
          向监管机构投诉，特别是向数据保护机构投诉， 你习惯居住或工作的国家。
        </p>
      </div>
    ),
  },
  {
    id: 'cookies',
    title: '9. Cookies',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          Cookies 是任何网站或应用程序可以传递到您浏览器的信息片段，
          这些随后会存储在你的电脑或移动系统中。例如，存款 cookies
          通过允许我们保存您的偏好来增强您的在线体验。
        </p>
        <p className="mt-4">我们使用 cookies 和自动收集的信息来：</p>
        <ol className="mt-2 list-decimal space-y-2 pl-4">
          <li>
            个性化我们的服务，例如记住您的数据，以便您在使用或下次使用我们的服务时无需 再次输入它；
          </li>
          <li>提供根据您的个人资料定制化的广告、内容和信息；</li>
          <li>监控和分析我们服务及第三方营销的有效性 根据您的个人资料定制的活动；</li>
          <li>监控总访客数和页面浏览量等综合站点使用指标； 和</li>
          <li>
            跟踪你的条目、提交和任何促销或其他活动的状态
            通过我们的服务（根据您的个人资料调整的服务）。
          </li>
        </ol>
        <p className="mt-4">
          追踪技术也有助于我们管理和提升 {PRODUCT_NAME} 的可用性。
          我们也可以以无法读取的方式收集您的缩短 IP 地址，这 不能使我们直接识别您。
        </p>
        <p className="mt-4">
          如果您不希望我们通过使用 Cookie 收集您的数据，您可以 将您的网络浏览器设置为拒绝来自
          {PRODUCT_NAME}的 Cookie。每个浏览器都不同，因此您
          应该检查你的浏览器的"帮助"菜单，了解如何更改你的 cookie 偏好设置。 请注意，如果您拒绝使用
          Cookie，您仍然可以使用我们的服务，但您的使用能力
          要访问我们服务的某些区域可能会受到限制或限制。
        </p>
        <p className="mt-4">
          如果你对我们处理你的具体信息有任何疑问， 保留，以及您对我们收集和使用实践的选择，请联系
          下面列出的信息。
        </p>
      </div>
    ),
  },
  {
    id: 'application',
    title: '10. 第三方应用程序',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>本政策仅适用于我们的服务。</p>
        <p className="mt-4">
          为了更好地丰富您的体验，我们的服务中可能包含指向其他非
          由我们（包括我们的附属公司）运营或控制的服务（包括支付服务）。您
          可以自行选择是否访问此类内容或链接，或是否使用第三方
          产品或服务。但是，我们无法控制产品或服务 由第三方提供。我们提供这些链接并不表示我们认可或
          我们已审查这些第三方服务。我们的政策不适用于或管辖这些数据。
          与您使用任何第三方服务或网站相关的保护问题。我们
          强烈建议您查看您访问的每个网站的隐私政策。
        </p>
        <p className="mt-4">
          如果本政策中的任何条款与任何适用法律冲突，则
          这些规定将被具有同等效力的新规定所取代，这些新规定反映了原始规定
          根据适用法律允许的程度，解释该条款的意图。在那
          如果是这种情况，其余条款仍然适用且保持不变。
        </p>
      </div>
    ),
  },
  {
    id: 'changes',
    title: '11. 政策变更',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          我们可能会不时更新、变更或修改本协议的条款，并且这些变更将
          构成本政策的组成部分。我们将通过在我们服务上发布一般公告或
          在您登录时向您发送通知来通知您这些变更。 更新网站，并可能根据其重要性获得您的同意，
          我们做出的更改，以及根据适用法律的要求。除非另有说明，任何更新，
          更改或修改将在通知当天生效，并适用于 您的所有数据。
        </p>
      </div>
    ),
  },
  {
    id: 'parental-consent',
    title: '12. 父母和监护人同意',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          我们的服务并非旨在或面向儿童，如适用定义所述
          你所在国家或地区的法律。例如，在韩国，“儿童”指的是 14
          岁以下人士，而在一些其他国家或地区，则指 13
          岁以下人士（"最低年龄"）。如果你已超过最低年龄但未达到
          你所在司法管辖区的成年年龄（"成年年龄"），你需要父母或
          监护人的许可和注册才能使用我们的服务。他们的同意意味着他们同意 代表您翻译此政策。
        </p>
        <p className="mt-4">
          我们不会有意收集或征求数据来自未达到最低年龄的儿童。如果您
          如果你是监护人，并且发现你照顾下的人使用了我们的服务或
          如果您提供了个人数据，请立即停止使用我们的服务并通知
          请立即通过本文件"联系方式"部分列出的联系信息与我们联系
          政策以便我们采取适当的行动。如果您希望查询或删除数据，请
          通过本政策的“联系方式”部分联系我们。我们的客服
          团队可能需要核实并确认监护权。一旦确认，我们将协助您 在删除您请求的数据和相应账户。
        </p>
      </div>
    ),
  },
  {
    id: 'contact-information',
    title: '13. 联系信息',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          如果您对此政策有任何投诉、建议或问题。 对收集、使用、披露、存储、保护及其他形式的处理
          您的数据，请联系我们通过电子邮件
          <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a> 或通过访问
          <a href="https://x.com/CodeFlicker_ai">https://x.com/CodeFlicker_ai</a>.
        </p>
        <p className="mt-4">
          如果根据当地法律需要任命一名数据保护官
          在您的司法管辖区，您也可以使用联系方式联系数据保护官员
          请参阅下方的“国家/地区特定条款”部分。
        </p>
        <p className="mt-4">
          我们将尽快审查相关问题并及时回复您 根据相关法律法规的要求。如果您对我们如何处理
          您的数据，请联系我们。我们将尽力迅速解决您的问题。
        </p>
      </div>
    ),
  },
  {
    id: 'country-specific',
    title: '14. 国家/地区特定条款',
    content: (
      <div className="span-normal text-base text-content-primary">
        <p>
          如果国家/地区特定条款的规定之间发生冲突，则
          与您访问或使用服务的司法管辖区相关，以及其余部分
          根据本政策，相关司法管辖区的国家/地区特定条款将优先适用 并且在与这种冲突的范围内取得胜利。
        </p>
        <p className="span-semibold mt-4">加利福尼亚州 (美国)</p>
        <p>
          如果你是加利福尼亚州的居民，以下是根据相关法律需要提供的额外隐私声明： 2018
          年加利福尼亚州消费者隐私法（"CCPA"）和其他加利福尼亚州法律可能
          适用于您并允许您行使其关于个人数据的权利。
        </p>
        <p className="span-semibold mt-4">1. 简介</p>
        <p>
          如果《加州消费者隐私法案》（CCPA）适用，您有权了解和理解我们如何收集、使用、
          公开和共享您的数据，访问您的数据，要求我们删除特定数据，行使您选择退出的权利，
          并且在不受歧视的情况下 行使你在 CCPA 下被授予的隐私权。
        </p>
        {/* 由于内容过长，这里省略了加州具体条款的其他内容 */}
        <p className="span-semibold mt-4">新加坡</p>
        <p className="span-semibold mt-2">数据保护官</p>
        <p>
          如果您希望访问您的数据、更正我们持有的数据、撤回您同意收集、使用或披露您的数据的同意，或者如果您对本政策有任何疑问或反馈，请通过以下方式联系我们的数据保护官员：
        </p>
        <p className="mt-2">注意：数据保护官员</p>
        <p>
          邮箱地址：<a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a>
        </p>
        <p className="span-semibold mt-4">国际数据传输</p>
        <p>
          如果你居住在新加坡，或者我们在新加坡收集或存储你的数据，在
          将您的任何数据转移到新加坡以外，我们将采取适当的措施
          确保收件人受具有法律约束力的义务约束，必须向 转移个人数据应达到至少与...同等的标准保护
          根据新加坡 2012 年《个人数据保护法》。
        </p>
        <p className="span-semibold mt-4">访问和更正</p>
        <p>
          如果你希望提出（一项）访问请求，以获取你的数据或信息的副本
          关于我们使用或披露您数据的方式，或（b）更正请求
          如果你需要更正或更新我们持有的关于你的任何数据，你可以提交你的请求到
          我们在上面提供的联系详情中的数据保护官将回应您的请求。 尽快。如果我们不能在
          收到您的请求后三十（30）天内，我们将书面通知您，并在三十天内
          （30）天内，我们将能够回应您的请求。如果 无法为您提供任何数据或进行您要求的更正，我们将
          通常告知您我们无法这样做的原因（除非我们无法这样做） 根据适用法律要求（如需这样做）。
        </p>
      </div>
    ),
  },
];

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="size-full">
      <NavBar />
      <PageWithTOC
        title="隐私政策"
        subtitle="发布日期：2025/08/04   生效日期：2025/08/04"
        sections={privacyPolicySections}
      />
      {/* <Signature className="fixed bottom-[244px] right-[120px]" /> */}
    </div>
  );
};

export default PrivacyPolicy;